function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { substitutionSchema } from "@superwall-me/schema";
import { z } from "zod";
const subsitutionsSchema = z.object({
    substitutions: z.array(substitutionSchema)
});
const paywallMiddleware = (db)=>{
    db.$use(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function*(params, next) {
            if (params.model === "Paywall" && [
                "create",
                "update"
            ].includes(params.action)) {
                if (params.args && params.args.data && params.args.data.substitutions) {
                    const parseResult = subsitutionsSchema.safeParse(params.args.data.substitutions);
                    if (!parseResult.success) {
                        if (params.action === "create") {
                            params.args.data.substitutions = {
                                substitutions: []
                            };
                        }
                        params.args.data.substitutions = undefined;
                    } else {
                        params.args.data.substitutions = parseResult.data;
                    }
                }
            }
            const result = yield next(params);
            // Transform  [] -> { substitutions: [] }
            if (params.model === "Paywall" && result && result.substitutions && Array.isArray(result.substitutions)) {
                result.substitutions = {
                    substitutions: []
                };
            }
            return result;
        });
        return function(params, next) {
            return _ref.apply(this, arguments);
        };
    }());
};
export default paywallMiddleware;
